import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { cn } from '../lib/utils';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Foire aux questions" className="bg-white" data-id="element-59" data-mp="1hemfbg2decto">
      <div className="mx-auto max-w-3xl px-5 py-16 lg:py-24" style={{
      paddingTop: "20px",
      paddingBottom: "23px"
    }} data-id="element-60" data-mp="1ceqajelumhd2">
        <h2 className="text-center font-display text-4xl font-extrabold uppercase leading-none text-navy sm:text-5xl" data-id="element-61" data-mp="2a2idyqbi2et3">
          Foire aux questions
        </h2>
        <div className="mt-10 divide-y divide-navy/10 border-y border-navy/10" data-id="element-62" data-mp="2042kigp02tgf">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-63" data-mp="1v46fqf8haxzt" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 py-5 text-left focus:outline-none focus-visible:text-electric" data-id="element-64" data-mp="1v72eu6w2bspu">
                  <span className={cn('text-base font-semibold transition-colors duration-150 ease-out', isOpen ? 'text-electric' : 'text-navy')} data-id="element-65" data-mp="1knzy6boe06tv">
                    {f.q}
                  </span>
                  <span className={cn('flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out', isOpen ? 'rotate-45 bg-electric text-white' : 'bg-warm text-navy/60')} data-id="element-66" data-mp="1apkfmx3fe5vz">
                    <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-67" data-mp="11w7ej7v7jxyt" />
                  </span>
                </button>
                <div className="grid transition-[grid-template-rows] duration-200 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-68" data-mp="16pihgxwwfulg">
                  <div className="overflow-hidden" data-id="element-69" data-mp="wxcq9qeh1h7b">
                    <div className="space-y-2 pb-5 pr-10 text-[15px] leading-relaxed text-navy/70" data-id="element-70" data-mp="ww1hfc665j9c">
                      {f.a.map(p => <p key={p} data-id="element-71" data-mp="mzyief6m60qm">{p}</p>)}
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}